<template>
    <div :class="$style.edit_version_indicator">
        <p v-if="edit_base_version_id">Edited Version: {{edit_base_version_id}}</p>
        <p>Published Version: {{published_version_id}}</p>
    </div>   
</template>

<script>
export default {
    name: 'EditVersionIndicator',
    props: {
        edit_base_version_id: {
            required: false,
            default: null
        },
        published_version_id: {
            type: Number,
            required: false,
            default: null
        }
    },
    created: function(){

    },
    data: function(){
        return {

        }
    },
    watch: {

    }
}
</script>

<style module>
.edit_version_indicator {
    position: fixed;
    top: 180px;
    right: 15px;
    width:12%;
    background-color: whitesmoke;
    border: 1px solid lightgrey;
    border-radius: 3px;    
    z-index: 1100;
    padding-left: 4px;
}

.edit_version_indicator p{
    font-weight: 500
}
</style>